<div class="uk-grid">
  <div class="uk-width-2-3" style="padding-right: 30px">
    <div class="uk-grid">
      <div class="uk-width-1-1"
           style="margin-bottom: 10px"
           *ngIf="false === isClient"
      >
        <search-client-select
          [isCreatingForm]="isCreatingForm"
          [clientId]="shipment.client_id"
          (onClientChangedEvent)="clientChangedEventHandler($event)"
        >
        </search-client-select>
      </div>

      <div class="uk-width-1-3" *ngIf="null !== shipment.client_id || isClient">
        <label>Rodzaj przesyłki</label>
        <select class="uk-select"
          (change)="serviceChanged();"
          [(ngModel)]="shipment.delivery_service"
          [disabled]="false === isCreatingForm"
          id="deliveryServiceId"
        >
          <option value="1">Home delivery</option>
          <option value="3">Locker delivery</option>
          <option value="2">Home return</option>
          <option value="4">Locker return</option>
        </select>
      </div>

      <div class="uk-width-1-3"
        *ngIf="isCreatingForm && (null !== shipment.client_id || isClient)"
      >
        <label> {{isReturnService() ? 'Kraj nadawcy' : 'Kraj odbiorcy'}}</label>
        <select class="uk-select" [(ngModel)]="selectedCountryId" id="countryId" (change)="countryChanged()">
          <option value="{{country.id}}" *ngFor="let country of countries">
            {{country.name}}
          </option>
        </select>
      </div>


      <div class="uk-width-1-1"
       style="margin-bottom: 20px"
        *ngIf="isReturnService() && (!isCreatingForm || null !== selectedCountryId)"
      >
        <app-interested-entity-view-component
          [name]="'Nadawca'"
          [type]="'sender'"
          [isSender]="true"
          [isLockerService]="isLockerService()"
          [disabled]="formDisabled"
          [interestedEntity]="shipment.sender"
          (onInterestedEntityChangedEvent)="interestedEntityChangedEventHandler(true, $event)"
          [validationErrors]="validationErrors"
          id="senderComponent"
        >
        </app-interested-entity-view-component>
      </div>
      <div class="uk-width-1-1"
           *ngIf="false === isReturnService() && (!isCreatingForm || null !== selectedCountryId)"
      >
        <app-interested-entity-view-component
          [name]="'Odbiorca'"
          [type]="'recipient'"
          [isSender]="false"
          [disabled]="formDisabled"
          [isLockerService]="isLockerService()"
          [interestedEntity]="shipment.recipient"
          (onInterestedEntityChangedEvent)="interestedEntityChangedEventHandler(false, $event)"
          [validationErrors]="validationErrors"
          id="recipientComponent"
        >

        </app-interested-entity-view-component>
      </div>
    </div>

    <div class="uk-width-1-1" *ngIf="(!isCreatingForm || null !== selectedCountryId)">
      <div class="uk-grid">
        <div class="uk-width-1-2">
          <label>Zawartość przesyłki</label>
          <input class="uk-input"
                 id="declaredContent"
                 [disabled]="formDisabled"
                 [(ngModel)]="shipment.content.declared_content"
          >
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="'content.declared_content'"
          ></app-validation-error-badge>
        </div>

        <div class="uk-width-1-4">
          <label>Zadeklarowna wartość</label>
          <input class="uk-input"
                 type="number"
                 id="declaredValue"
                 step="0.01"
                 min="0"
                 [disabled]="formDisabled"
                 [(ngModel)]="shipment.content.declared_value"
          >
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="'content.declared_value'"
          ></app-validation-error-badge>
        </div>
        <div class="uk-width-1-4">
          <label>Waluta</label>
          <input class="uk-input"
                 id="declaredValueCurrency"
                 disabled
                 [ngModel]="shipment.content.currency"
          >
        </div>
      </div>

      <p class="uk-heading-divider">
        {{'parcel_aggrements' | translate}}
      </p>

      <div class="uk-width-1-1@m">
        <label>
          <input [disabled]="formDisabled"
                 class="uk-checkbox"
                 type="checkbox"
                 id="cashOnDeliveryCheckbox"
                 value="1"
                 #cash_on_delivery="ngModel"
                 [(ngModel)]="shipmentCod"
                 (change)="cashOnDeliveryChanged()"
                 autocomplete="none"
          >
          {{'cash_on_delivery' | translate}}
        </label>
      </div>

      <div class="uk-width-1-1 uk-margin-top uk-margin-bottom" *ngIf="shipmentCod">
        <div class="uk-grid">
          <div class="uk-width-1-3">
            <label>Kwota pobrania</label>
            <input class="uk-input"
                   id="cashOnDeliveryValue"
                   [disabled]="formDisabled"
                   [(ngModel)]="shipment.content.cash_on_delivery_value"
            >
            <app-validation-error-badge
              [validationErrors]="validationErrors"
              [activatorKey]="'content.cash_on_delivery_value'"
            ></app-validation-error-badge>
          </div>
          <div class="uk-width-1-4">
            <label>Waluta</label>
            <input class="uk-input"
                   disabled
                   id="cashOnDeliveryValueCurrency"
                   [ngModel]="shipment.content.currency"
            >
          </div>
        </div>
      </div>

      <button class="uk-button"
              style="margin-top: 20px;"
              *ngIf="false === formDisabled && isCreatingForm"
              (click)="submitStore();"
      >
       Utwórz
      </button>

      <button class="uk-button"
              style="margin-top: 20px;"
              *ngIf="false === formDisabled && false === isCreatingForm"
              (click)="submitUpdate();"
      >
        Zapisz
      </button>

    </div>
  </div>
  <div class="uk-width-1-3 uk-" *ngIf="null === shipment?.waybill && null !== selectedCountryId">
    <table class="uk-table uk-table-striped uk-padding-remove-horizontal">
      <tr>
        <th>
          LP
        </th>
        <th style="width: 19%">
          Waga
        </th>
        <th style="width: 19%">
          Wysokość
        </th>
        <th style="width: 19%">
          Szerokość
        </th>
        <th style="width: 19%">
          Długość
        </th>
        <th style="width: 19%"></th>
      </tr>
      <tr  *ngFor="let parcel of shipment.parcels; let i = index">
        <td style="font-weight: bold; vertical-align: center">
          {{ (i+1) }}
        </td>
        <td>
          <input class="uk-input" min="0.1" step="0.01" id="parcels.{{i}}.weight" [(ngModel)]="parcel.weight.declared">
        </td>
        <td>
          <input class="uk-input" min="10" step="1" id="parcels.{{i}}.height" [(ngModel)]="parcel.dimensions.declared.height">
        </td>
        <td>
          <input class="uk-input" min="10" step="1" id="parcels.{{i}}.width" [(ngModel)]="parcel.dimensions.declared.width">
        </td>
        <td>
          <input class="uk-input" min="10" step="1" id="parcels.{{i}}.length" [(ngModel)]="parcel.dimensions.declared.length">
        </td>
        <td>
          <button class="uk-button padding-horizontal-small"
            *ngIf="i !== 0"
            (click)="deleteParcel(i);"
          >
            <span uk-icon="trash"></span>
          </button>
        </td>
      </tr>
    </table>

    <app-validation-error-badge
      *ngFor="let a of shipment.parcels; let i = index"
      [validationErrors]="validationErrors"
      [activatorKey]="'parcels.' + i + '.dimensions.declared.height'"
    ></app-validation-error-badge>

    <app-validation-error-badge
      *ngFor="let a of shipment.parcels; let i = index"
      [validationErrors]="validationErrors"
      [activatorKey]="'parcels.' + i + '.dimensions.declared.length'"
    ></app-validation-error-badge>

    <app-validation-error-badge
      *ngFor="let a of shipment.parcels; let i = index"
      [validationErrors]="validationErrors"
      [activatorKey]="'parcels.' + i + '.dimensions.declared.width'"
    ></app-validation-error-badge>

    <app-validation-error-badge
      *ngFor="let a of shipment.parcels; let i = index"
      [validationErrors]="validationErrors"
      [activatorKey]="'parcels.' + i + '.weight.declared'"
    ></app-validation-error-badge>

    <button class="uk-button uk-button-primary"
      style="margin-top: 10px"
      [disabled]="isLockerService() || shipment.parcels.length > 20"
      (click)="addParcel()"
      id="addNextParcelButton"
    >
      Dodaj kolejną przesyłkę
    </button>
  </div>


  <div class="uk-width-1-3" *ngIf="null !== shipment?.waybill">
    <div class="uk-grid">
      <app-shipment-card-button
        class="uk-width-1-3 uk-padding-remove-horizontal"
        [hidden]="shipment?.parcels.length === 1"
        *ngFor="let parcel of shipment?.parcels ?? []"
        [text]="parcel.waybill.internal"
        [cardName]="parcel.waybill.internal"
        [activeCardName]="activeParcelCardName"
        (buttonClicked)="activeParcelCardChanged($event)"
        title="Szczegóły przesyłki {{parcel.waybill.internal}}"
      >

      </app-shipment-card-button>
    </div>
    <div
      class="uk-grid"
      *ngFor="let parcel of shipment?.parcels ?? []"
      [hidden]="activeParcelCardName !== parcel.waybill.internal"
    >
      <div class="uk-width-1-1 uk-padding-remove-horizontal">
        <table class="uk-table uk-table-striped">
          <tr *ngIf="!shipment.internal_info.is_return && null === findBufferNumber() && null !== shipment.external_couriers.last_mile">
            <td>Kurier last mile</td>
            <td>{{shipment.external_couriers.last_mile}}</td>
          </tr>

          <tr *ngIf="!shipment.internal_info.is_return && null === findBufferNumber()">
            <td>
              Numer wyjściowy
            </td>
            <td>
              <kbd> {{parcel.waybill.external_last_mile ?? '-'}} </kbd>
            </td>
          </tr>

          <tr *ngIf="!shipment.internal_info.is_return && '-' !== parcel.waybill.external_return">
            <td>
              Numer zwrotny
            </td>
            <td>
              <kbd> {{parcel.waybill.external_return}} </kbd>
            </td>
          </tr>

          <tr *ngIf="null !== parcel.waybill.external_duplicated">
            <td>
              N. zduplikowanej przesyłki
            </td>
            <td>
              <kbd> {{parcel.waybill.external_duplicated}} </kbd>
            </td>
          </tr>

          <tr *ngIf="null !== parcel.waybill.external_buffer">
            <td>
              N. oczekujacy w buforze
            </td>
            <td>
              {{parcel.waybill.external_buffer}}
            </td>
          </tr>

          <tr *ngIf="shipment.internal_info.is_return">
            <td>Kurier</td>
            <td>{{shipment.external_couriers.first_mile}}</td>
          </tr>

          <tr *ngIf="shipment.internal_info.is_return">
            <td>
              Numer wyjściowy
            </td>
            <td>
              <kbd> {{parcel.waybill.external_first_mile ?? '-'}} </kbd>
            </td>
          </tr>

          <tr>
            <td></td>
            <td></td>
          </tr>

          <tr *ngIf="!shipment.internal_info.is_return" title="Data przyjęcia w magazynie wysyłkowym">
            <td>Przyj. w mag. wysyłkowym</td>
            <td>{{parcel.timestamps.shipping_warehouse_received_at ?? '-'}}</td>
          </tr>

          <tr *ngIf="!shipment.internal_info.is_return" title="Data doręczenia">
            <td>Doręczona</td>
            <td>{{parcel.timestamps.delivered_at ?? '-'}}</td>
          </tr>

          <tr *ngIf="shipment.internal_info.is_return || null !== parcel.timestamps.return_warehouse_received_at" title="Data przyjęcia w magazynie zwrotów">
            <td>Przyj. w mag. wysyłkowym</td>
            <td>{{parcel.timestamps.return_warehouse_received_at ?? '-'}}</td>
          </tr>


          <tr>
            <td></td>
            <td></td>
          </tr>

          <!-- todo dodać wagę wolumetryczną -->

          <tr>
            <td>Waga zmierzona</td>
            <td>{{parcel.weight.measured}} kg</td>
          </tr>

          <tr>
            <td>Wysokość zmierzona</td>
            <td>{{parcel.dimensions.measured.height}} cm</td>
          </tr>

          <tr>
            <td>Szerokość zmierzona</td>
            <td>{{parcel.dimensions.measured.width}} cm</td>
          </tr>

          <tr>
            <td>Długość zmierzona</td>
            <td>{{parcel.dimensions.measured.length}} cm</td>
          </tr>

          <tr>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td>Waga zadeklarowana</td>
            <td>{{parcel.weight.declared}} kg</td>
          </tr>

          <tr>
            <td>Wysokość zadeklarowana</td>
            <td>{{parcel.dimensions.declared.height}} cm</td>
          </tr>

          <tr>
            <td>Szerokość zadeklarowana</td>
            <td>{{parcel.dimensions.declared.width}} cm</td>
          </tr>

          <tr>
            <td>Długość zadeklarowana</td>
            <td>{{parcel.dimensions.declared.length}} cm</td>
          </tr>

        </table>
      </div>
    </div>
  </div>
</div>
